import React from 'react';
import {
    BackButton,
    BackButtonIconType,
    H2Emphasized,
    H5Emphasized,
    isNonMobileWeb,
    XStack,
    YStack,
} from 'smoothie';

interface ProfileHeaderProps {
    title?: string;
    titleSize?: 'medium' | 'large';
    titleIcon?: React.ReactElement;
    hideBackButton?: boolean;
    customBackFn?: () => void;
}

export const ProfileHeader = ({
    title,
    titleSize,
    titleIcon,
    hideBackButton = false,
    customBackFn,
}: ProfileHeaderProps) => {
    const TitleComponent = titleSize === 'medium' ? H5Emphasized : H2Emphasized;

    return (
        <YStack>
            <XStack
                marginBottom={18}
                paddingLeft={isNonMobileWeb ? 8 : 16}
                paddingTop={4}
            >
                {!hideBackButton && (
                    <BackButton
                        iconType={BackButtonIconType.ARROW_LEFT}
                        customBackFn={customBackFn}
                    />
                )}
            </XStack>
            {title != null && (
                <XStack alignItems="center" gap={16}>
                    {titleIcon}
                    <TitleComponent marginBottom={18}>{title}</TitleComponent>
                </XStack>
            )}
        </YStack>
    );
};
